export default __webpack_public_path__ + "static/media/babybiberon 1.20c525fd.png";